import { string } from "prop-types";

import CloseButton from "../shared/CloseButton";

const ActiveState = ({ color }) => <CloseButton color={color} text="Close" />;

ActiveState.propTypes = { color: string };

export default ActiveState;
